const DEVICE_ID_KEY = 'edv-next.device-id';
let fallbackDeviceId: string | null = null;

export function getOrCreateWebDeviceId(): string {
  if (typeof globalThis.localStorage !== 'undefined') {
    const stored = globalThis.localStorage.getItem(DEVICE_ID_KEY);
    if (stored) return stored;
    const created = globalThis.crypto.randomUUID();
    globalThis.localStorage.setItem(DEVICE_ID_KEY, created);
    return created;
  }
  fallbackDeviceId ??= globalThis.crypto.randomUUID();
  return fallbackDeviceId;
}
